<template>
    <div class="index">
        <div class="flash">
            <div class="gg">
                <div><div class="topNav minColor">产品</div></div>
                <div class="title">自动化测试</div>
                <div class="minTitle minColor">颠覆传统、单一的软件测试服务模式，依托十余年自动化测试经验，结合专业测试工具，为企业客户提供功能测试、兼容测试、性能测试、安全测试等多种自动化测试服务。帮助企业客户从反复枯燥的低价值测试任务中解脱出来，提高测试效率与质量。</div>
                <!-- <div class="button">咨询详情</div> -->
            </div>
        </div>
       <picture>
            <source srcset="@/assets/images/zd1_mb.jpg" media="(max-width:768px)" alt="">
            <img class="flashImg" src="@/assets/images/zd1.png" />
        </picture>
       <div class="lxwm bg1">
            <div class="content">
                <div class="title1 tc">国内自动化测试的痛点</div>
                <div class="items mt5 pb20">
                    <div class="item2">
                        <div class="tit">
                            <img src="@/assets/images/zd2.png" />
                            <div class="lb">
                                国内自动化测试的痛点
                            </div>
                        </div>
                        <div class="minTitle2">
                            代码一旦发生变化，经常导致自动化脚本无法执行，需要重新修改。
                        </div>
                    </div>
                    <div class="item2">
                        <div class="tit">
                            <img src="@/assets/images/zd3.png" />
                            <div class="lb">
                                无法自动化生成脚本
                            </div>
                        </div>
                        <div class="minTitle2">
                            自动化生成测试脚本的技术还不够成熟，需要较多测试人员手工编写自动化测试脚本
                        </div>
                    </div>
                    <div class="item2 item3">
                        <div class="tit">
                            <img src="@/assets/images/zd4.png" />
                            <div class="lb">
                                控件识别技术存在瓶颈
                            </div>
                        </div>
                        <div class="minTitle2">
                            前端技术越来越多，导致自动化测试对控件识别的难度越来越大
                        </div>
                    </div>
                </div>
                <div class="title1 tc mt20">产品优势</div>
                <div class="contLine">
                    <div class="item left">
                        <img src="@/assets/images/zd5.png" /><span>%</span>
                        <div class="minTitle">功能测试</div>
                        <div class="line"></div>
                    </div>
                    <div class="item center">
                        <img src="@/assets/images/zd6.png" /><span>%</span>
                        <div class="minTitle">重复测试</div>
                        <div class="line"></div>
                    </div>
                    <div class="item right">
                        <img src="@/assets/images/zd7.png" /><span>%</span>
                        <div class="minTitle">创新应用</div>
                        <div class="line"></div>
                    </div>
                </div>
                <div class="items pb20 gou">
                    <div class="item2">
                        <div class="tit">
                            <img src="@/assets/images/zd8.png" />
                            <div class="lb">
                                自动化
                            </div>
                        </div>
                        <div class="mt10"></div>
                        <div class="minTitle2">自动生成测试用例、测试文档</div>
                        <div class="minTitle2">全自动控件识别、控件定位</div>
                    </div>
                    <div class="item2">
                        <div class="tit">
                            <img src="@/assets/images/zd9.png" />
                            <div class="lb">
                                智能化
                            </div>
                        </div>
                        <div class="mt10"></div>
                        <div class="minTitle2">等待时间，智能调整</div>
                        <div class="minTitle2">环境错误，智能判断</div>
                    </div>
                    <div class="item2 item3">
                        <div class="tit">
                            <img src="@/assets/images/zd10.png" />
                            <div class="lb">
                                智能化
                            </div>
                        </div>
                        <div class="mt10"></div>
                        <div class="minTitle2">兼容性测试，免修改</div>
                        <div class="minTitle2">多系统联调，交叉测试</div>
                    </div>
                </div>
            </div>
       </div>
       <div class="lxwm bg3">
            <div class="content">
                <div class="title1 tc">产品功能</div>
                <div class="flex">
                    <div class="items mt5">
                        <div class="item2">
                            <div class="tit">
                                <img src="@/assets/images/zd11.png" />
                                <div class="lb">
                                    测试流程优化
                                </div>
                            </div>
                            <div class="minTitle2">
                                测试用例自动生成；场景融合，多系统联调；项目经理在线检查测试结果
                            </div>
                        </div>
                        <div class="item2">
                            <div class="tit">
                                <img src="@/assets/images/zd12.png" />
                                <div class="lb">
                                    实现快速测试
                                </div>
                            </div>
                            <div class="minTitle2">
                                新建测试；屏幕录制；可视化用例自动执行；自动生成测试报告；
                            </div>
                        </div>
                        <div class="item2 item3">
                            <div class="tit">
                                <img src="@/assets/images/zd13.png" />
                                <div class="lb">
                                    覆盖浏览器，图形软件，操作系统
                                </div>
                            </div>
                            <div class="minTitle2">
                                覆盖图形软件；主流浏览器；操作系统
                            </div>
                        </div>
                        <div class="item2">
                            <div class="tit">
                                <img src="@/assets/images/zd14.png" />
                                <div class="lb">
                                    兼容性测试自动化
                                </div>
                            </div>
                            <div class="minTitle2">
                                支持 IChrome,Firefox 等跨浏览器的全自动比较。
                                支持不同执行机器、不同分辨率、不同时间点的，全自动比较。
                                支持 界面元素的值、位置、大小、颜色等10多种属性自动比较。
                            </div>
                        </div>
                        <div class="item2">
                            <div class="tit">
                                <img src="@/assets/images/zd15.png" />
                                <div class="lb">
                                    接口测试
                                </div>
                            </div>
                            <div class="minTitle2">
                                通过外部接口、客户端接口来测试后台服务端的功能是否满足应用系统定义的功能需求。
                            </div>
                        </div>
                        <div class="item2 item3">
                            <div class="tit">
                                <img src="@/assets/images/zd16.png" />
                                <div class="lb">
                                    项目管理优化
                                </div>
                            </div>
                            <div class="minTitle2">
                                快速测试，远程管理，风险可控。
                            </div>
                        </div>
                    </div>
                </div>
            </div>
       </div>
       <div class="lxwm bg2 pb30">
            <div class="content">
                <div class="title1 tc">竞品分析</div>
                <img class="buttonImg" src="@/assets/images/zd17.png" />
            </div>
       </div>
    </div>
</template>
<script>
    export default {
        components: {
        },
        data() {
            return {
                
            }
        },
        methods: {
            
        }
    }
</script>

<style lang="less" scoped>
    .index {
        .flashImg {
            width: 100%;
            height: calc(30w);
        }
        .bg3 {
            background-color: #efefef;
        }
        .buttonImg {
            margin-top: 20px;
            width: 100%;
            height: auto;
        }
        .pb30 {
            padding-bottom: 30px !important;
        }
        .lxwm {
            padding: 30px 0 0;
            .contLine {
                padding-top: 30px;
                padding-bottom: 50px;
                background: url(../../assets/images/dw.png) no-repeat;
                background-size: 100% 100%;
                .item {
                    display: inline-block;
                    img {
                        width: 53px;
                        height: 30px;
                    }
                    .minTitle {
                        margin-top: 10px;
                    }
                    .line {
                        height: 4px;
                        width: 28px;
                        margin-top: 5px;
                        background: -webkit-linear-gradient(right, #3C91FF, #6BDEFF);
                        background: -o-linear-gradient(right, #3C91FF, #6BDEFF);
                        background: -moz-linear-gradient(right, #3C91FF, #6BDEFF);
                        background: linear-gradient(to right,#3C91FF, #6BDEFF);
                    }
                }
                .left {
                    margin-left: 27%;
                }
                .center {
                    margin-left: 15%;
                }
                .right {
                    margin-left: 15%;
                }
            }
            .items {
                display: flex;
                flex-wrap: wrap;
                .item {
                    margin-top: 10px;
                    width: 10.66%;
                    background-color: #ffffff;
                    padding: 15px 3%;
                    text-align: center;
                    img {
                        height: 35px;
                    }
                    .lb {
                       margin-top: 10px;
                    }
                }

                .item2 {
                    width: 27.33%;
                    background-color: #ffffff;
                    margin-right: 3%;
                    padding: 15px 2%;
                    margin-bottom: 20px;
                    min-height: 110px;
                    img {
                        height: 30px;
                        margin-right: 10px;
                    }
                    .lb {
                        display: inline-block;
                        font-size: 16px;
                        font-weight: 500;
                        line-height: 35px;
                        vertical-align: bottom;
                    }
                    .minTitle2 {
                        margin-top: 10px;
                        line-height: 20px;
                    }
                }
                .item3 {
                    margin-right: 0;
                    
                }
            }
            .gou {
                .minTitle2 {
                    margin-top: 5px !important;
                    background: url(../../assets/images/rpa17.png) no-repeat;
                    background-size: auto 60%;
                    background-position-y: center;
                    text-indent: 17px;
                }
            }
        }
    }
</style>
<style lang="less" scoped>
@media (max-width: 1230px) {
  .index {
    .flash {
      position: relative;
      padding: 0 50px;
      .gg .title {
        font-size: 24px;
      }
    }
    .flashImg {
      height: 100vh;
    }
  }
}
@media (max-width: 960px) {
  .index {
    .flash {
      .gg {
        .title {
          font-size: 20px;
        }
        .minTitle {
          width: 46%;
          font-size: 13px;
        }
        .button {
          padding: 6px 15px;
          margin-top: 20px;
        }
      }
    }
  }
}
@media (max-width: 768px) {
    .index {
        .flash {
            padding: 0 15px;
            .minTitle {
                width: 50%;
                font-size: 13px;
            }
            .gg {
                top: 50px;
                .title {
                    font-size: 20px;
                }
                .button {
                    padding: 6px 15px;
                    margin-top: 20px;
                }
            }
            
        }
        .flashImg {
            height: 40vh;
        }
        .content .title1 {
            margin: 0;
            margin-bottom: 20px;
        }
        .lxwm {
            .contLine {
                display: flex;
                justify-content: space-evenly;
                padding-top: 10px;
                padding-bottom: 30px;
                .left {
                    margin-left: 0;
                }
                .item {
                    img {
                        width: 38px;
                        height: auto;
                    }
                    .minTitle {
                        margin-top: 5px;
                        font-size: 12px;
                    }
                    .line {
                        width: 20px;
                    }
                }
            }
            .items .item2 {
                width: 100%;
                margin-right: 0;
                margin-bottom: 15px;
                padding: 20px 15px;
                min-height: 80px;
                
                .minTitle2 {
                    font-size: 13px;
                }
                .tit {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    img {
                        height: 20px;
                    }
                }
            }
            .items :last-of-type {
                margin-bottom: 0;
            }
        }
        .lxwm.bg3 {
            background-color: #f6f8ff;
            .items {
                justify-content: space-between;
                .tit {
                    display: inline-block;
                    width: 100%;
                    text-align: center;
                    img {
                        vertical-align: bottom;
                    }
                    .lb {
                        display: inline;
                        line-height: normal;
                    }
                }
                .item2 {
                    width: 49%;
                    box-sizing: border-box;
                    padding: 20px 13px;
                }
                .item2:last-of-type {
                    margin-bottom: 15px;
                }
                img {
                    height: 20px;
                }
            }
        }
        .lxwm.bg2.pb30 {
            background-color: #f6f8ff;
            .buttonImg {
                margin-top: 0;
            }
        }
    }
}
</style>